import { Reducer } from './Reducer';

const reducers = {
    'Auth/reducer': require('./source/Auth/reducer'),
    'BreadCrumb/reducer': require('./source/BreadCrumb/reducer'),
    'Categories/reducer': require('./source/Categories/reducer'),
    'Colors/reducer': require('./source/Colors/reducer'),
    'Countries/reducer': require('./source/Countries/reducer'),
    'Customers/reducer': require('./source/Customers/reducer'),
    'Documents/reducer': require('./source/Documents/reducer'),
    'Designs/reducer': require('./source/Designs/reducer'),
    'Internalization/reducer': require('./source/Internalization/reducer'),
    'Items/reducer': require('./source/Items/reducer'),
    'ItemSpecifications/reducer': require('./source/ItemSpecifications/reducer'),
    'Orders/reducer': require('./source/Orders/reducer'),
    'Page/reducer': require('./source/Page/reducer'),
    'Packages/reducer': require('./source/Packages/reducer'),
    'Salesman/reducer': require('./source/Salesman/reducer'),
    'Sizes/reducer': require('./source/Sizes/reducer'),
    'SizingRanges/reducer': require('./source/SizingRanges/reducer'),
    'Skus/reducer': require('./source/Skus/reducer'),
    'SkuGenders/reducer': require('./source/SkuGenders/reducer'),
    'Sports/reducer': require('./source/Sports/reducer'),
    'Transactions/reducer': require('./source/Transactions/reducer'),
    'User/reducer': require('./source/User/reducer'),
    'Locations/reducer': require('./source/Locations/reducer'),
    'NotificationAlert/reducer': require('./source/NotificationAlert/reducer'),
    'Wholesaler/reducer': require('./source/Wholesaler/reducer'),
};

export function cleanModules(modules) {
    return Object.keys(modules).map((file) => {
        const module = modules[file];
        module.__FILE__ = file;
        return module;
    });
}

export const Reducers = cleanModules(reducers).reduce((bag, reducer) => {
    try {
        if (reducer.default) {
            const Reducer$ = reducer.default;
            const instance = new Reducer$();

            if (instance instanceof Reducer || instance.__IS_REDUCER__) {
                if (instance.NAME) {
                    bag[instance.NAME] = instance.reducer.bind(instance);
                } else {
                    // noinspection ExceptionCaughtLocallyJS
                    throw new Error('[NAME: string] property not found!');
                }
            } else {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error("Isn't instance of Reducer!");
            }
        } else {
            // noinspection ExceptionCaughtLocallyJS
            throw new Error("Default export don't exist!");
        }
    } catch (e) {
        console.warn(`[WARN]: Reducer '${reducer.__FILE__}' couldn't register! {\n\t${e.message}\n}`);
    }

    return bag;
}, {});
